import { useState } from "react";
import { ListBanner } from "../components/banner/ListBanner";
import { CreateBanner } from "../components/banner/CreateBanner";
import { UpdateBanner } from "../components/banner/UpdateBanner";

export const Banner = () => {
  const [mode, setMode] = useState<"create" | "edit" | "list">("list");
  const [selectedId, setSelectedId] = useState<string | null>(null);

  if (mode === "create") {
    return <CreateBanner onBack={() => setMode("list")} />;
  }

  if (mode === "edit" && selectedId) {
    return (
      <UpdateBanner onBack={() => setMode("list")} selectedId={selectedId} />
    );
  }
  return (
    <ListBanner
      onCreate={() => setMode("create")}
      onUpdate={(id: string) => {
        setSelectedId(id);
        setMode("edit");
      }}
    />
  );
};
